// Keep a person's disclosure choice when LiveView updates controls inside it.
export default {
  beforeUpdate() { this.disclosureOpen = this.el.open },
  updated() { this.el.open = this.disclosureOpen }
}
